module.exports = __webpack_public_path__ + "img/a-sky-view-of-earth-from-suomi-npp_16611703184_o_small.5343c101.jpg";